export const PARTNER_PLAN_KEYS = {
  BASIC: 'basic',
  PREMIUM: 'premium',
  PRO: 'pro',
};

export const DEFAULT_PARTNER_ACCEPT_PLANS = [
  { key: PARTNER_PLAN_KEYS.BASIC, amount: 55 },
  { key: PARTNER_PLAN_KEYS.PREMIUM, amount: 120 },
  { key: PARTNER_PLAN_KEYS.PRO, amount: 200 },
];

export const PARTNER_PLAN_LABELS = {
  [PARTNER_PLAN_KEYS.BASIC]: 'Basic',
  [PARTNER_PLAN_KEYS.PREMIUM]: 'Premium',
  [PARTNER_PLAN_KEYS.PRO]: 'Pro',
};

export const createDefaultPartnerAcceptPlans = () =>
  DEFAULT_PARTNER_ACCEPT_PLANS.map((plan) => ({ ...plan }));

export const normalizePartnerAcceptPlans = (plans = DEFAULT_PARTNER_ACCEPT_PLANS) =>
  plans.map((plan) => ({
    key: String(plan.key ?? '').trim(),
    amount: Number(plan.amount),
  }));

export const arePartnerAcceptPlansValid = (plans) =>
  normalizePartnerAcceptPlans(plans).every(
    (plan) => plan.key && Number.isFinite(plan.amount) && plan.amount >= 0,
  );

export const buildPartnerLiveStatusPayload = (plans) => ({
  status: 'live',
  plans: normalizePartnerAcceptPlans(plans),
});
